import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, inject, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { provideGroundworksAuth } from '@groundworks/ngx-groundworks-auth';
import { IMAGEKIT_THUMBNAIL_CONFIG } from '@groundworks/ngx-groundworks-ui';
import { routes } from './app.routes';
import { buildGroundworksAuthConfig, resolveApiUrl } from './auth.config';
import { ConfigService } from './config.service';
import { ImageKitThumbnailConfigFactory } from './factories/imagekit-thumbnail-config-factory';
import { API_BASE_URL } from "./sdk/sdk";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimationsAsync(),
    provideHttpClient(
      withInterceptorsFromDi()
    ),
    {
      provide: API_BASE_URL,
      useFactory: resolveApiUrl,
      deps: [ConfigService]
    },
    {
      provide: IMAGEKIT_THUMBNAIL_CONFIG,
      useFactory: ImageKitThumbnailConfigFactory,
      deps: [ConfigService]
    },
    provideRouter(routes),
    provideGroundworksAuth(() => buildGroundworksAuthConfig(inject(ConfigService))),
  ]
};
